export function decibelsToLinear(db) {
    return Math.pow(10.0, 0.05 * db);
}

export function linearToDecibels(x) {
    return 20.0 * Math.log(x) / Math.LN10;
}
